import CustomInput from "../CustomInput";

const FIVE_SYMBOLS = /(^$)|(^[1-9][0-9А-ЕЖ-ЩЬЮЯЇІЄҐ'-/]{0,7}$)/;

class BuildingInput extends CustomInput {
  transform = value => this.clearSpaces(value).toUpperCase();

  validate = value => FIVE_SYMBOLS.test(value);
}

export default BuildingInput;

// import React from "react";
// import MaskedInput from "react-maskedinput";
//
// export default function BuildingInput(props) {
//   const mask = "X".repeat(10);
//
//   return (
//     <MaskedInput
//       mask={mask}
//       placeholder=""
//       placeholderChar=" "
//       {...props}
//       formatCharacters={{
//         X: {
//           validate: char => /[А-ЕЖ-ЩЬЮЯЇІЄҐа-еж-щьюяїієґ'-//\d]/.test(char),
//           transform: char => char.toUpperCase()
//         }
//       }}
//     />
//   );
// }
